import React from 'react';
import { Link } from 'react-router-dom';

import NotFoundCanonical from 'components/global/application/NotFoundCanonical';

import './NotFoundPage.sass';

class NotFoundPage extends React.Component<{}> {
    public render() {
        return (
            <div className="not-found">
                <NotFoundCanonical />
                <h2>Not Found</h2>
                <p>Sorry, we couldn't find that content.</p>
                <Link to="/">Return to the Home Page</Link>
            </div>
        );
    }
}

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/components/pages/notFound/NotFoundPage.tsx